import { createSlice } from '@reduxjs/toolkit';

export const selectedFeatureSlice = createSlice({
    name: 'selectedFeature',
    initialState: {
        loteSelecionado: null,
        tabelaSelecionado: null,
        featureProperties: null
    },
    reducers: {
        setSelectedFeature: (state, action) => {
            state.loteSelecionado = action.payload.lote;
            state.tabelaSelecionado = action.payload.tabela;
            state.featureProperties = action.payload.properties;
        },
        clearSelectedFeature: (state) => {
            state.loteSelecionado = null;
            state.tabelaSelecionado = null;
            state.featureProperties = null;
        }
    }
});

export const { setSelectedFeature, clearSelectedFeature } = selectedFeatureSlice.actions;
export default selectedFeatureSlice.reducer;